import React from 'react';
import PropTypes from 'prop-types';

const textTruncate = (str, length = 60, ending = '...') => {
  if (str.length > length) {
    return str.substring(0, length - ending.length) + ending;
  }

  return str;
};

const SearchListItemTitle = props => (
  <h3 className="afd-search-list__title">{textTruncate(props.title)}</h3>
);

SearchListItemTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default SearchListItemTitle;
